export {default} from './Loader';
export type {ILoaderProps} from './Loader';
